import { convertToURI } from "@/lib/icons/utils";

export const checkIcon = convertToURI(
  `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.8182 5.75L9.44319 18.25L5.18182 12.5682" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
);
